export var IdTemplateType;
(function (IdTemplateType) {
    IdTemplateType["DriversLicense"] = "drivers-license";
    IdTemplateType["Passport"] = "passport";
    IdTemplateType["Handgun"] = "handgun";
    IdTemplateType["Identification"] = "identification";
    IdTemplateType["DriversLicensePermit"] = "drivers-license-permit";
    IdTemplateType["CommercialLicense"] = "commercial-license";
    IdTemplateType["Residence"] = "residence";
    IdTemplateType["Indian"] = "indian";
    IdTemplateType["GlobalEntry"] = "global-entry";
    IdTemplateType["HealthInsurance"] = "health-insurance";
    IdTemplateType["AetnaInsurance"] = "aetna-insurance";
    IdTemplateType["CvsRx"] = "cvs-rx";
    IdTemplateType["UhcInsurance"] = "uhc-insurance";
    IdTemplateType["CignaInsurance"] = "cigna-insurance";
    IdTemplateType["PassportCard"] = "passport-card";
    IdTemplateType["Other"] = "other";
    IdTemplateType["Citizen"] = "citizen";
    IdTemplateType["Nexus"] = "nexus";
    IdTemplateType["Visa"] = "visa";
    IdTemplateType["Employment"] = "employment";
    IdTemplateType["MatriculaConsular"] = "matricula-consular";
    IdTemplateType["Indigenous"] = "indigenous";
    IdTemplateType["Sentri"] = "sentri";
})(IdTemplateType || (IdTemplateType = {}));
export const idTemplateTypes = Object.values(IdTemplateType);
// eslint-disable-next-line import-x/no-unused-modules
export var ExtractionFieldName;
(function (ExtractionFieldName) {
    ExtractionFieldName["Optional12"] = "__optional__12.__";
    ExtractionFieldName["Optional2"] = "__optional__2.__";
    ExtractionFieldName["Optional4b"] = "__optional__4b__";
    ExtractionFieldName["OptionalAlphabets"] = "__optional__alphabets__";
    ExtractionFieldName["OptionalAlphanumeric"] = "__optional__alphanumeric__";
    ExtractionFieldName["OptionalDdlasthalf"] = "__optional__ddlasthalf__";
    ExtractionFieldName["OptionalDobmonth_"] = "__optional__dob__month__";
    ExtractionFieldName["OptionalDobyear_"] = "__optional__dob__year__";
    ExtractionFieldName["OptionalDONOR"] = "__optional__DONOR__";
    ExtractionFieldName["OptionalEXACT"] = "__optional__EXACT__";
    ExtractionFieldName["OptionalMonth"] = "__optional__month__";
    ExtractionFieldName["OptionalNOT"] = "__optional__NOT__";
    ExtractionFieldName["OptionalNumber"] = "__optional__number__";
    ExtractionFieldName["OptionalNumber1"] = "__optional__number1__";
    ExtractionFieldName["OptionalNumber2"] = "__optional__number2__";
    ExtractionFieldName["OptionalOriginal_"] = "__optional__original_";
    ExtractionFieldName["OptionalYear"] = "__optional__year__";
    ExtractionFieldName["Optional1Name"] = "__optional_1_name__";
    ExtractionFieldName["Optional8Address"] = "__optional_8_address__";
    ExtractionFieldName["Address"] = "address";
    ExtractionFieldName["Address1"] = "address1";
    ExtractionFieldName["Affiliation1"] = "affiliation1";
    ExtractionFieldName["AHCD"] = "AHCD";
    ExtractionFieldName["Audit"] = "audit";
    ExtractionFieldName["BloodType"] = "blood_type";
    ExtractionFieldName["CdlRestrictions"] = "cdl_restrictions";
    ExtractionFieldName["Cheveux"] = "cheveux";
    ExtractionFieldName["CINo"] = "CI_no";
    ExtractionFieldName["Class"] = "class";
    ExtractionFieldName["ClientNo"] = "client_no";
    ExtractionFieldName["Copies"] = "copies";
    ExtractionFieldName["CountryCode"] = "country_code";
    ExtractionFieldName["CountryOfBirth"] = "country_of_birth";
    ExtractionFieldName["Cpf"] = "cpf";
    ExtractionFieldName["CUIL"] = "CUIL";
    ExtractionFieldName["CURP"] = "CURP";
    ExtractionFieldName["DateOfRegistration"] = "date_of_registration";
    ExtractionFieldName["Dd"] = "dd";
    ExtractionFieldName["DdContd"] = "dd_contd";
    ExtractionFieldName["Dob"] = "dob";
    ExtractionFieldName["Dob2"] = "dob2";
    ExtractionFieldName["Donor"] = "donor";
    ExtractionFieldName["Dups"] = "dups";
    ExtractionFieldName["EarliestExam"] = "earliest_exam";
    ExtractionFieldName["Endorsements"] = "endorsements";
    ExtractionFieldName["Expires"] = "expires";
    ExtractionFieldName["Eyes"] = "eyes";
    ExtractionFieldName["FamilyName"] = "family_name";
    ExtractionFieldName["FatherName"] = "father_name";
    ExtractionFieldName["FilingDate"] = "filing_date";
    ExtractionFieldName["FirstLicensed"] = "first_licensed";
    ExtractionFieldName["FirstName"] = "first_name";
    ExtractionFieldName["FirstName1"] = "first_name1";
    ExtractionFieldName["FirstName2"] = "first_name2";
    ExtractionFieldName["Flag"] = "flag";
    ExtractionFieldName["Gender"] = "gender";
    ExtractionFieldName["Hair"] = "hair";
    ExtractionFieldName["Header"] = "header";
    ExtractionFieldName["Height"] = "height";
    ExtractionFieldName["HoldersSignature"] = "holder's signature";
    ExtractionFieldName["Hologram"] = "hologram";
    ExtractionFieldName["IdCardNumber"] = "id_card_number";
    ExtractionFieldName["IdNumber"] = "id_number";
    ExtractionFieldName["IdNumber2"] = "id_number2";
    ExtractionFieldName["Issued"] = "issued";
    ExtractionFieldName["IssuingAuthority"] = "issuing_authority";
    ExtractionFieldName["LastName"] = "last_name";
    ExtractionFieldName["LastName1"] = "last_name1";
    ExtractionFieldName["LastName2"] = "last_name2";
    ExtractionFieldName["Logo"] = "logo";
    ExtractionFieldName["Logo2"] = "logo2";
    ExtractionFieldName["MaritalStatus"] = "marital_status";
    ExtractionFieldName["Name"] = "name ";
    ExtractionFieldName["NameAddress"] = "name_address";
    ExtractionFieldName["Nationality"] = "nationality";
    ExtractionFieldName["Occupation"] = "occupation";
    ExtractionFieldName["Office"] = "office";
    ExtractionFieldName["Parish"] = "parish";
    ExtractionFieldName["PersonalNumber"] = "personal_number";
    ExtractionFieldName["PlaceOfBirth"] = "place_of_birth";
    ExtractionFieldName["PlaceOfIssuance"] = "place_of_issuance";
    ExtractionFieldName["Remarks"] = "remarks";
    ExtractionFieldName["Restrictions"] = "restrictions";
    ExtractionFieldName["Revision"] = "revision";
    ExtractionFieldName["RfcNumber"] = "rfc_number";
    ExtractionFieldName["Seal"] = "seal";
    ExtractionFieldName["Sim"] = "sim";
    ExtractionFieldName["Status"] = "status";
    ExtractionFieldName["Type"] = "type";
    ExtractionFieldName["Type2"] = "type2";
    ExtractionFieldName["Under18Until"] = "under_18_until";
    ExtractionFieldName["Under21Until"] = "under_21_until";
    ExtractionFieldName["Weight"] = "weight";
    ExtractionFieldName["Yeux"] = "yeux";
})(ExtractionFieldName || (ExtractionFieldName = {}));
// eslint-disable-next-line import-x/no-unused-modules
export const extractionFieldNames = Object.values(ExtractionFieldName);
export var Country;
(function (Country) {
    Country["AD"] = "AD";
    Country["AE"] = "AE";
    Country["AF"] = "AF";
    Country["AG"] = "AG";
    Country["AI"] = "AI";
    Country["AL"] = "AL";
    Country["AM"] = "AM";
    Country["AN"] = "AN";
    Country["AO"] = "AO";
    Country["AQ"] = "AQ";
    Country["AR"] = "AR";
    Country["AS"] = "AS";
    Country["AT"] = "AT";
    Country["AU"] = "AU";
    Country["AW"] = "AW";
    Country["AX"] = "AX";
    Country["AZ"] = "AZ";
    Country["BA"] = "BA";
    Country["BB"] = "BB";
    Country["BD"] = "BD";
    Country["BE"] = "BE";
    Country["BF"] = "BF";
    Country["BG"] = "BG";
    Country["BH"] = "BH";
    Country["BI"] = "BI";
    Country["BJ"] = "BJ";
    Country["BL"] = "BL";
    Country["BM"] = "BM";
    Country["BN"] = "BN";
    Country["BO"] = "BO";
    Country["BQ"] = "BQ";
    Country["BR"] = "BR";
    Country["BS"] = "BS";
    Country["BT"] = "BT";
    Country["BV"] = "BV";
    Country["BW"] = "BW";
    Country["BY"] = "BY";
    Country["BZ"] = "BZ";
    Country["CA"] = "CA";
    Country["CC"] = "CC";
    Country["CD"] = "CD";
    Country["CF"] = "CF";
    Country["CG"] = "CG";
    Country["CH"] = "CH";
    Country["CI"] = "CI";
    Country["CK"] = "CK";
    Country["CL"] = "CL";
    Country["CM"] = "CM";
    Country["CN"] = "CN";
    Country["CO"] = "CO";
    Country["CR"] = "CR";
    Country["CS"] = "CS";
    Country["CU"] = "CU";
    Country["CV"] = "CV";
    Country["CW"] = "CW";
    Country["CX"] = "CX";
    Country["CY"] = "CY";
    Country["CZ"] = "CZ";
    Country["DE"] = "DE";
    Country["DJ"] = "DJ";
    Country["DK"] = "DK";
    Country["DM"] = "DM";
    Country["DO"] = "DO";
    Country["DZ"] = "DZ";
    Country["EC"] = "EC";
    Country["EE"] = "EE";
    Country["EG"] = "EG";
    Country["EH"] = "EH";
    Country["ER"] = "ER";
    Country["ES"] = "ES";
    Country["ET"] = "ET";
    Country["FI"] = "FI";
    Country["FJ"] = "FJ";
    Country["FK"] = "FK";
    Country["FM"] = "FM";
    Country["FO"] = "FO";
    Country["FR"] = "FR";
    Country["GA"] = "GA";
    Country["GB"] = "GB";
    Country["GD"] = "GD";
    Country["GE"] = "GE";
    Country["GF"] = "GF";
    Country["GG"] = "GG";
    Country["GH"] = "GH";
    Country["GI"] = "GI";
    Country["GL"] = "GL";
    Country["GM"] = "GM";
    Country["GN"] = "GN";
    Country["GP"] = "GP";
    Country["GQ"] = "GQ";
    Country["GR"] = "GR";
    Country["GS"] = "GS";
    Country["GT"] = "GT";
    Country["GU"] = "GU";
    Country["GW"] = "GW";
    Country["GY"] = "GY";
    Country["HK"] = "HK";
    Country["HM"] = "HM";
    Country["HN"] = "HN";
    Country["HR"] = "HR";
    Country["HT"] = "HT";
    Country["HU"] = "HU";
    Country["ID"] = "ID";
    Country["IE"] = "IE";
    Country["IL"] = "IL";
    Country["IM"] = "IM";
    Country["IN"] = "IN";
    Country["IO"] = "IO";
    Country["IQ"] = "IQ";
    Country["IR"] = "IR";
    Country["IS"] = "IS";
    Country["IT"] = "IT";
    Country["JE"] = "JE";
    Country["JM"] = "JM";
    Country["JO"] = "JO";
    Country["JP"] = "JP";
    Country["KE"] = "KE";
    Country["KG"] = "KG";
    Country["KH"] = "KH";
    Country["KI"] = "KI";
    Country["KM"] = "KM";
    Country["KN"] = "KN";
    Country["KP"] = "KP";
    Country["KR"] = "KR";
    Country["KW"] = "KW";
    Country["KY"] = "KY";
    Country["KZ"] = "KZ";
    Country["LA"] = "LA";
    Country["LB"] = "LB";
    Country["LC"] = "LC";
    Country["LI"] = "LI";
    Country["LK"] = "LK";
    Country["LR"] = "LR";
    Country["LS"] = "LS";
    Country["LT"] = "LT";
    Country["LU"] = "LU";
    Country["LV"] = "LV";
    Country["LY"] = "LY";
    Country["MA"] = "MA";
    Country["MC"] = "MC";
    Country["MD"] = "MD";
    Country["ME"] = "ME";
    Country["MF"] = "MF";
    Country["MG"] = "MG";
    Country["MH"] = "MH";
    Country["MK"] = "MK";
    Country["ML"] = "ML";
    Country["MM"] = "MM";
    Country["MN"] = "MN";
    Country["MO"] = "MO";
    Country["MP"] = "MP";
    Country["MQ"] = "MQ";
    Country["MR"] = "MR";
    Country["MS"] = "MS";
    Country["MT"] = "MT";
    Country["MU"] = "MU";
    Country["MV"] = "MV";
    Country["MW"] = "MW";
    Country["MX"] = "MX";
    Country["MY"] = "MY";
    Country["MZ"] = "MZ";
    Country["NA"] = "NA";
    Country["NC"] = "NC";
    Country["NE"] = "NE";
    Country["NF"] = "NF";
    Country["NG"] = "NG";
    Country["NI"] = "NI";
    Country["NL"] = "NL";
    Country["NO"] = "NO";
    Country["NP"] = "NP";
    Country["NR"] = "NR";
    Country["NU"] = "NU";
    Country["NZ"] = "NZ";
    Country["OM"] = "OM";
    Country["PA"] = "PA";
    Country["PE"] = "PE";
    Country["PF"] = "PF";
    Country["PG"] = "PG";
    Country["PH"] = "PH";
    Country["PK"] = "PK";
    Country["PL"] = "PL";
    Country["PM"] = "PM";
    Country["PN"] = "PN";
    Country["PR"] = "PR";
    Country["PS"] = "PS";
    Country["PT"] = "PT";
    Country["PW"] = "PW";
    Country["PY"] = "PY";
    Country["QA"] = "QA";
    Country["RE"] = "RE";
    Country["RO"] = "RO";
    Country["RS"] = "RS";
    Country["RU"] = "RU";
    Country["RW"] = "RW";
    Country["SA"] = "SA";
    Country["SB"] = "SB";
    Country["SC"] = "SC";
    Country["SD"] = "SD";
    Country["SE"] = "SE";
    Country["SG"] = "SG";
    Country["SH"] = "SH";
    Country["SI"] = "SI";
    Country["SJ"] = "SJ";
    Country["SK"] = "SK";
    Country["SL"] = "SL";
    Country["SM"] = "SM";
    Country["SN"] = "SN";
    Country["SO"] = "SO";
    Country["SR"] = "SR";
    Country["SS"] = "SS";
    Country["ST"] = "ST";
    Country["SV"] = "SV";
    Country["SX"] = "SX";
    Country["SY"] = "SY";
    Country["SZ"] = "SZ";
    Country["TC"] = "TC";
    Country["TD"] = "TD";
    Country["TF"] = "TF";
    Country["TG"] = "TG";
    Country["TH"] = "TH";
    Country["TJ"] = "TJ";
    Country["TK"] = "TK";
    Country["TL"] = "TL";
    Country["TM"] = "TM";
    Country["TN"] = "TN";
    Country["TO"] = "TO";
    Country["TR"] = "TR";
    Country["TT"] = "TT";
    Country["TV"] = "TV";
    Country["TW"] = "TW";
    Country["TZ"] = "TZ";
    Country["UA"] = "UA";
    Country["UG"] = "UG";
    Country["UM"] = "UM";
    Country["US"] = "US";
    Country["UY"] = "UY";
    Country["UZ"] = "UZ";
    Country["VA"] = "VA";
    Country["VC"] = "VC";
    Country["VE"] = "VE";
    Country["VG"] = "VG";
    Country["VI"] = "VI";
    Country["VN"] = "VN";
    Country["VU"] = "VU";
    Country["WF"] = "WF";
    Country["WS"] = "WS";
    Country["XK"] = "XK";
    Country["YE"] = "YE";
    Country["YT"] = "YT";
    Country["ZA"] = "ZA";
    Country["ZM"] = "ZM";
    Country["ZW"] = "ZW";
})(Country || (Country = {}));
export const countryNames = {
    [Country.AD]: 'Andorra',
    [Country.AE]: 'United Arab Emirates',
    [Country.AF]: 'Afghanistan',
    [Country.AG]: 'Antigua and Barbuda',
    [Country.AI]: 'Anguilla',
    [Country.AL]: 'Albania',
    [Country.AM]: 'Armenia',
    [Country.AN]: 'Netherlands Antilles',
    [Country.AO]: 'Angola',
    [Country.AQ]: 'Antarctica',
    [Country.AR]: 'Argentina',
    [Country.AS]: 'American Samoa',
    [Country.AT]: 'Austria',
    [Country.AU]: 'Australia',
    [Country.AW]: 'Aruba',
    [Country.AX]: 'Åland Islands',
    [Country.AZ]: 'Azerbaijan',
    [Country.BA]: 'Bosnia and Herzegovina',
    [Country.BB]: 'Barbados',
    [Country.BD]: 'Bangladesh',
    [Country.BE]: 'Belgium',
    [Country.BF]: 'Burkina Faso',
    [Country.BG]: 'Bulgaria',
    [Country.BH]: 'Bahrain',
    [Country.BI]: 'Burundi',
    [Country.BJ]: 'Benin',
    [Country.BM]: 'Bermuda',
    [Country.BN]: 'Brunei Darussalam',
    [Country.BO]: 'Bolivia',
    [Country.BR]: 'Brazil',
    [Country.BS]: 'Bahamas',
    [Country.BT]: 'Bhutan',
    [Country.BV]: 'Bouvet Island',
    [Country.BW]: 'Botswana',
    [Country.BY]: 'Belarus',
    [Country.BZ]: 'Belize',
    [Country.CA]: 'Canada',
    [Country.CC]: 'Cocos (Keeling) Islands',
    [Country.CD]: 'Congo, The Democratic Republic of the',
    [Country.CF]: 'Central African Republic',
    [Country.CG]: 'Congo',
    [Country.CH]: 'Switzerland',
    [Country.CI]: "Cote D'Ivoire",
    [Country.CK]: 'Cook Islands',
    [Country.CL]: 'Chile',
    [Country.CM]: 'Cameroon',
    [Country.CN]: 'China',
    [Country.CO]: 'Colombia',
    [Country.CR]: 'Costa Rica',
    [Country.CS]: 'Serbia and Montenegro',
    [Country.CU]: 'Cuba',
    [Country.CV]: 'Cabo Verde',
    [Country.CX]: 'Christmas Island',
    [Country.CY]: 'Cyprus',
    [Country.CZ]: 'Czech Republic',
    [Country.DE]: 'Germany',
    [Country.DJ]: 'Djibouti',
    [Country.DK]: 'Denmark',
    [Country.DM]: 'Dominica',
    [Country.DO]: 'Dominican Republic',
    [Country.DZ]: 'Algeria',
    [Country.EC]: 'Ecuador',
    [Country.EE]: 'Estonia',
    [Country.EG]: 'Egypt',
    [Country.EH]: 'Western Sahara',
    [Country.ER]: 'Eritrea',
    [Country.ES]: 'Spain',
    [Country.ET]: 'Ethiopia',
    [Country.FI]: 'Finland',
    [Country.FJ]: 'Fiji',
    [Country.FK]: 'Falkland Islands (Malvinas)',
    [Country.FM]: 'Micronesia, Federated States of',
    [Country.FO]: 'Faroe Islands',
    [Country.FR]: 'France',
    [Country.GA]: 'Gabon',
    [Country.GB]: 'United Kingdom',
    [Country.GD]: 'Grenada',
    [Country.GE]: 'Georgia',
    [Country.GF]: 'French Guiana',
    [Country.GG]: 'Guernsey',
    [Country.GH]: 'Ghana',
    [Country.GI]: 'Gibraltar',
    [Country.GL]: 'Greenland',
    [Country.GM]: 'Gambia',
    [Country.GN]: 'Guinea',
    [Country.GP]: 'Guadeloupe',
    [Country.GQ]: 'Equatorial Guinea',
    [Country.GR]: 'Greece',
    [Country.GS]: 'South Georgia and the South Sandwich Islands',
    [Country.GT]: 'Guatemala',
    [Country.GU]: 'Guam',
    [Country.GW]: 'Guinea-Bissau',
    [Country.GY]: 'Guyana',
    [Country.HK]: 'Hong Kong',
    [Country.HM]: 'Heard Island and Mcdonald Islands',
    [Country.HN]: 'Honduras',
    [Country.HR]: 'Croatia',
    [Country.HT]: 'Haiti',
    [Country.HU]: 'Hungary',
    [Country.ID]: 'Indonesia',
    [Country.IE]: 'Ireland',
    [Country.IL]: 'Israel',
    [Country.IM]: 'Isle of Man',
    [Country.IN]: 'India',
    [Country.IO]: 'British Indian Ocean Territory',
    [Country.IQ]: 'Iraq',
    [Country.IR]: 'Iran, Islamic Republic Of',
    [Country.IS]: 'Iceland',
    [Country.IT]: 'Italy',
    [Country.JE]: 'Jersey',
    [Country.JM]: 'Jamaica',
    [Country.JO]: 'Jordan',
    [Country.JP]: 'Japan',
    [Country.KE]: 'Kenya',
    [Country.KG]: 'Kyrgyzstan',
    [Country.KH]: 'Cambodia',
    [Country.KI]: 'Kiribati',
    [Country.KM]: 'Comoros',
    [Country.KN]: 'Saint Kitts and Nevis',
    [Country.KP]: "Korea, Democratic People's Republic of",
    [Country.KR]: 'Korea, Republic of',
    [Country.KW]: 'Kuwait',
    [Country.KY]: 'Cayman Islands',
    [Country.KZ]: 'Kazakhstan',
    [Country.LA]: "Lao People's Democratic Republic",
    [Country.LB]: 'Lebanon',
    [Country.LC]: 'Saint Lucia',
    [Country.LI]: 'Liechtenstein',
    [Country.LK]: 'Sri Lanka',
    [Country.LR]: 'Liberia',
    [Country.LS]: 'Lesotho',
    [Country.LT]: 'Lithuania',
    [Country.LU]: 'Luxembourg',
    [Country.LV]: 'Latvia',
    [Country.LY]: 'Libyan Arab Jamahiriya',
    [Country.MA]: 'Morocco',
    [Country.MC]: 'Monaco',
    [Country.MD]: 'Moldova, Republic of',
    [Country.MG]: 'Madagascar',
    [Country.MH]: 'Marshall Islands',
    [Country.MK]: 'Macedonia, The Former Yugoslav Republic of',
    [Country.ML]: 'Mali',
    [Country.MM]: 'Myanmar',
    [Country.MN]: 'Mongolia',
    [Country.MO]: 'Macao',
    [Country.MP]: 'Northern Mariana Islands',
    [Country.MQ]: 'Martinique',
    [Country.MR]: 'Mauritania',
    [Country.MS]: 'Montserrat',
    [Country.MT]: 'Malta',
    [Country.MU]: 'Mauritius',
    [Country.MV]: 'Maldives',
    [Country.MW]: 'Malawi',
    [Country.MX]: 'Mexico',
    [Country.MY]: 'Malaysia',
    [Country.MZ]: 'Mozambique',
    [Country.NA]: 'Namibia',
    [Country.NC]: 'New Caledonia',
    [Country.NE]: 'Niger',
    [Country.NF]: 'Norfolk Island',
    [Country.NG]: 'Nigeria',
    [Country.NI]: 'Nicaragua',
    [Country.NL]: 'Netherlands',
    [Country.NO]: 'Norway',
    [Country.NP]: 'Nepal',
    [Country.NR]: 'Nauru',
    [Country.NU]: 'Niue',
    [Country.NZ]: 'New Zealand',
    [Country.OM]: 'Oman',
    [Country.PA]: 'Panama',
    [Country.PE]: 'Peru',
    [Country.PF]: 'French Polynesia',
    [Country.PG]: 'Papua New Guinea',
    [Country.PH]: 'Philippines',
    [Country.PK]: 'Pakistan',
    [Country.PL]: 'Poland',
    [Country.PM]: 'Saint Pierre and Miquelon',
    [Country.PN]: 'Pitcairn',
    [Country.PR]: 'Puerto Rico',
    [Country.PS]: 'Palestinian Territory, Occupied',
    [Country.PT]: 'Portugal',
    [Country.PW]: 'Palau',
    [Country.PY]: 'Paraguay',
    [Country.QA]: 'Qatar',
    [Country.RE]: 'Reunion',
    [Country.RO]: 'Romania',
    [Country.RU]: 'Russian Federation',
    [Country.RW]: 'RWANDA',
    [Country.SA]: 'Saudi Arabia',
    [Country.SB]: 'Solomon Islands',
    [Country.SC]: 'Seychelles',
    [Country.SD]: 'Sudan',
    [Country.SE]: 'Sweden',
    [Country.SG]: 'Singapore',
    [Country.SH]: 'Saint Helena',
    [Country.SI]: 'Slovenia',
    [Country.SJ]: 'Svalbard and Jan Mayen',
    [Country.SK]: 'Slovakia',
    [Country.SL]: 'Sierra Leone',
    [Country.SM]: 'San Marino',
    [Country.SN]: 'Senegal',
    [Country.SO]: 'Somalia',
    [Country.SR]: 'Suriname',
    [Country.ST]: 'Sao Tome and Principe',
    [Country.SV]: 'El Salvador',
    [Country.SY]: 'Syrian Arab Republic',
    [Country.SZ]: 'Swaziland',
    [Country.TC]: 'Turks and Caicos Islands',
    [Country.TD]: 'Chad',
    [Country.TF]: 'French Southern Territories',
    [Country.TG]: 'Togo',
    [Country.TH]: 'Thailand',
    [Country.TJ]: 'Tajikistan',
    [Country.TK]: 'Tokelau',
    [Country.TL]: 'Timor-Leste',
    [Country.TM]: 'Turkmenistan',
    [Country.TN]: 'Tunisia',
    [Country.TO]: 'Tonga',
    [Country.TR]: 'Turkey',
    [Country.TT]: 'Trinidad and Tobago',
    [Country.TV]: 'Tuvalu',
    [Country.TW]: 'Taiwan',
    [Country.TZ]: 'Tanzania, United Republic of',
    [Country.UA]: 'Ukraine',
    [Country.UG]: 'Uganda',
    [Country.UM]: 'United States Minor Outlying Islands',
    [Country.US]: 'United States',
    [Country.UY]: 'Uruguay',
    [Country.UZ]: 'Uzbekistan',
    [Country.VA]: 'Holy See (Vatican City State)',
    [Country.VC]: 'Saint Vincent and the Grenadines',
    [Country.VE]: 'Venezuela',
    [Country.VG]: 'Virgin Islands, British',
    [Country.VI]: 'Virgin Islands, U.S.',
    [Country.VN]: 'Viet Nam',
    [Country.VU]: 'Vanuatu',
    [Country.WF]: 'Wallis and Futuna',
    [Country.WS]: 'Samoa',
    [Country.XK]: 'Kosovo',
    [Country.YE]: 'Yemen',
    [Country.YT]: 'Mayotte',
    [Country.ZA]: 'South Africa',
    [Country.ZM]: 'Zambia',
    [Country.ZW]: 'Zimbabwe',
    [Country.BL]: 'Saint Barthélemy',
    [Country.BQ]: 'Bonaire, Sint Eustatius and Saba',
    [Country.CW]: 'Curaçao',
    [Country.ME]: 'Montenegro',
    [Country.MF]: 'Saint Martin (French part)',
    [Country.RS]: 'Serbia',
    [Country.SS]: 'South Sudan',
    [Country.SX]: 'Sint Maarten (Dutch part)'
};
